import React from "react";
import { useIntl } from "react-intl";
import { Formik, Form, Field } from "formik";
import { Button, DialogContent, DialogActions } from "@material-ui/core";
import { TextField } from "formik-material-ui";
import { createDialogConfirm } from "../../../../_common";
import { maybeCallback } from "../../../../_common/utils/fp";

export default function useConfirmarTransferencia({ ids, onClose = x => x, onSave = x => x }) {
  const intl = useIntl();

  const confirmar = close => {
    maybeCallback(close)();
    onSave();
  };

  function validarTransferencia(value) {
    if (value !== ids.length.toString()) {
      return intl.formatMessage({
        defaultMessage: "Informe o valor certo de Leads a serem transferidos",
      });
    }
    return "";
  }

  function confirmarTransferencia() {
    createDialogConfirm({
      title: intl.formatMessage(
        { defaultMessage: "Você irá transferir {quantidade} Lead(s), deseja continuar?" },
        { quantidade: ids.length }
      ),
      text: intl.formatMessage({
        defaultMessage:
          "A propriedade do Lead e suas atividades serão transferidas para outro usuário. Para continuar, digite o número de Leads que serão transferidos:",
      }),
      tamanhoMaximo: "sm",
      actions: close => (
        <Formik initialValues={{ quantidadeLeads: "" }} onSubmit={() => confirmar(close)} onReset={onClose}>
          {() => (
            <Form>
              <DialogContent style={{ display: "flex", flexDirection: "column" }}>
                <Field
                  component={TextField}
                  label={intl.formatMessage({
                    defaultMessage: "Confirme a quantidade de Leads a serem transferidos:",
                  })}
                  name="quantidadeLeads"
                  required
                  validate={validarTransferencia}
                  InputLabelProps={{ style: { fontSize: 13 } }}
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={close}>{intl.formatMessage({ defaultMessage: "Cancelar" })}</Button>
                <Button color="primary" type="submit">
                  {intl.formatMessage({ defaultMessage: "Confirmar transferência de Leads" })}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      ),
    });
  }

  return {
    confirmarTransferencia,
  };
}
